import React from "react";
import bgImage from "@/assets/images/header-bg.png";

import Image from "next/image";

export interface PageHeaderProps {
    heading: string;
    subHeading: string;
}

export default function PageHeader({ heading, subHeading }: PageHeaderProps) {
    if (!heading && !subHeading) {
        return null;
    }
    return (
        <div className="relative w-full min-h-[50vh] xl:min-h-[400px] xl:max-h-[500px] overflow-hidden mt-10 md:h-80 px-4 text-center flex flex-col items-center justify-center">
            <div className="z-1 flex h-auto absolute bottom-[20%] 2xl:bottom-[30%] flex-col items-center justify-center p-5 ">
                <h1 className="mt-8 mb-4 text-xl lg:text-5xl md:text-10 text-white text-center">
                    {heading}
                </h1>
                <p className="mb-4 font-roboto text-xxs md:text-sm text-white text-center">
                    {subHeading}
                </p>
            </div>
            <Image
                src={bgImage}
                alt=""
                fill
                priority
                className="object-cover"
            />
        </div>
    );
}
